/* 🔴 THE WHOLE ROW OPENS IT — his 2026-09-28 word, after William's first look at the Library: *"make sure in the
   library if workouts or exercises are as list view anywhere we tap in the row it will open. except of course their
   options on the right of the row"*.

   ONE rule for both tables (the Workouts table and the exercise shelf), so the two lists cannot answer the same tap
   differently. The row's NAME stays a real link — it is the keyboard's and the screen reader's way in, and a
   middle-click on it still opens a tab; the row click is the POINTER's larger target on top of it, never instead.

   ⚠️ WHAT A ROW CLICK MUST NOT SWALLOW: anything that is already a control (a link, a button, a field, a menu), and
   anything inside the row's actions cell — "their options on the right". And a coach dragging across a name to copy
   it is selecting text, not opening the row. */

/** Every element inside a row that answers a click itself. A click landing in one of these is theirs. */
export const ROW_CONTROL_SELECTOR =
  "a, button, input, select, textarea, label, summary, [role='menu'], [role='menuitem'], .ours-actions";

export type RowClick = {
  /** The click landed inside a control or the actions cell (`target.closest(ROW_CONTROL_SELECTOR)`). */
  readonly insideControl: boolean;
  /** Text is selected in the page — the coach was selecting, not opening. */
  readonly selectingText: boolean;
  /** `MouseEvent.button` — only the primary button opens. */
  readonly button: number;
};

/** Whether a click on a library row should open that row. */
export function rowClickOpens(click: RowClick): boolean {
  return click.button === 0 && !click.insideControl && !click.selectingText;
}

/** The `onClick` a library row carries: opens `to` (a `#/…` href) unless the click was a control's. A cmd/ctrl-click
 *  opens it in a new tab, as a click on the name link would. */
export function openRowOnClick(to: string): (e: { target: EventTarget | null; button: number; metaKey: boolean; ctrlKey: boolean }) => void {
  return (e) => {
    const target = e.target instanceof Element ? e.target : null;
    const click: RowClick = {
      insideControl: target?.closest(ROW_CONTROL_SELECTOR) != null,
      selectingText: (window.getSelection()?.toString() ?? "") !== "",
      button: e.button,
    };
    if (!rowClickOpens(click)) return;
    if (e.metaKey || e.ctrlKey) { window.open(to, "_blank"); return; }
    window.location.hash = to.startsWith("#") ? to.slice(1) : to;
  };
}
